import { makeStyles } from '@material-ui/core/styles';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import moment from 'moment';
import { color } from '../../app/theme';
import IconXCircleBlack from '../../assets/images/Icons/IconXCircleBlack';
import icPlus from '../../assets/images/svg/ic-plus.svg';
import { findTag } from '../../features/organizationSlice';
import Button from './Button';
import TagConditionPopup from './TagConditionPopup';

const useStyles = makeStyles(
  () => ({
    row: {
      display: 'flex',
      fontFamily: 'PingFang TC',
      fontWeight: 400,
      fontSize: 15,
      lineHeight: '21px',
      color: color.$11,
      backgroundColor: color.$19,
      borderRadius: 22,
      padding: '10px 28px 10px 16px',
      cursor: 'pointer',
      alignItems: 'center',
      flexWrap: 'wrap',
      '& > svg': {
        position: 'absolute',
        right: '8px',
      },
    },
    leftText: {
      color: color.$12,
    },
    leftRightText: {
      color: color.$12,
      marginLeft: 4,
      marginRight: 4,
    },
  }),
  {
    name: 'TagCondition',
  },
);

const TagCondition = ({
  onAddConditionValue,
  condition,
  disabled,
  disabledDate,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const tagCandidates = useSelector(store => store.organization.tagCandidates);

  const TYPE_ENUM = {
    INCLUDE: 'include',
    EXCLUDE: 'exclude',
    ANY_GREATER: 'anyGreater',
    NONE: 'none',
  };

  const [isOpen, setOpen] = useState(false);

  const type = condition?.value?.type;

  const handleSetDefault = () => {
    onAddConditionValue({
      type: TYPE_ENUM.NONE,
    });
  };

  const handleClearAll = () => {
    onAddConditionValue({});
  };

  const renderText = () => {
    return (
      <div
        className={classes.row}
        onClick={() => {
          if (!disabled) {
            setOpen(!isOpen);
          }
        }}
      >
        <div>
          {!disabledDate && (
            <>
              {condition.value.startDate && condition.value.endDate ? (
                <>
                  {t('tagCondition.setTime')}
                  <span className={classes.leftText}>
                    {moment(condition.value.startDate).format('YYYY-MM-DD')} ~{' '}
                    {moment(condition.value.endDate).format('YYYY-MM-DD')}，
                  </span>
                </>
              ) : (
                `${t('tagCondition.noSetTime')}，`
              )}
            </>
          )}
          {type === TYPE_ENUM.INCLUDE && (
            <>
              {t('tagCondition.include')}

              <span className={classes.leftText}>
                {condition.value.tags.join('、')}
              </span>

              {condition.value.count && (
                <>
                  ，{t('tagCondition.andTaging')}
                  <span className={classes.leftRighyText}>
                    {condition.value.count}
                  </span>
                  {t('tagCondition.count')}
                </>
              )}
            </>
          )}

          {type === TYPE_ENUM.EXCLUDE && (
            <>
              {t('tagCondition.exclude')}
              <span className={classes.leftText}>
                {condition.value.tags.join('、')}
              </span>
            </>
          )}

          {type === TYPE_ENUM.ANY_GREATER && (
            <>
              {t('tagCondition.someTagCount')}
              {condition.value.count && (
                <>
                  <span className={classes.leftRightText}>
                    {condition.value.count}
                  </span>
                  {t('tagCondition.count')}
                </>
              )}
            </>
          )}
          {type === TYPE_ENUM.NONE && t('tagCondition.noTag')}
        </div>
        {!disabled && (
          <IconXCircleBlack
            id="delete-icon"
            onClick={e => {
              e.stopPropagation();
              handleClearAll();
            }}
          />
        )}
      </div>
    );
  };

  return (
    <div style={{ position: 'relative' }}>
      {condition.value?.type ? (
        renderText()
      ) : (
        <Button
          type="submit"
          topic="IconPrimaryGrey"
          onClick={() => {
            if (!isOpen && !condition.value?.type) {
              handleSetDefault();
            }

            setOpen(!isOpen);
          }}
          disabled={disabled}
        >
          <img src={icPlus} alt="addTag" />
          {t('tagCondition.tagCondition')}
        </Button>
      )}

      {isOpen && (
        <TagConditionPopup
          onAddConditionValue={onAddConditionValue}
          conditionValue={condition?.value}
          disabled={disabled}
          setOpen={setOpen}
          findTag={findTag}
          tagCandidates={tagCandidates}
          disabledDate={disabledDate}
        />
      )}
    </div>
  );
};

export default TagCondition;
